import styles from '../styles/components/paymentWindow.module.css';
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import Overview from './Overview';
import config from '../config';
import { useContext, useEffect, useRef, useState } from 'react';
import { StoreContext } from '..';
import { observer } from 'mobx-react-lite';
import Spinner from './Spinner';
import WaitPaidInvoice from './WaitPaidInvoice';
import PaymentService from '../services/payment';


interface ComponentProps {
    cancel: Function;
    autoPromoCode?: string;
};


function PaymentWindow({
    cancel, 
    autoPromoCode = ""
}: ComponentProps) {
    const tg = window.Telegram.WebApp;
    const {appStore} = useContext(StoreContext);
    const [deposit, setDeposit] = useState("100");
    const [promoCode, setPromoCode] = useState(autoPromoCode);
    const [promoCodePercentBonus, setPromoCodePercentBonus] = useState(0);
    const [submitPromoCodeProcess, setSubmitPromoCodeProcess] = useState(false);
    const inputDepositRef = useRef(null);

    // const products = appStore.products.filter(p => p.product_type === 'promocoin').sort((a, b) => a.product_value - b.product_value);

    useEffect(() => {
        if (autoPromoCode) {
            submitPromoCode();
        }
    }, []);

    const updateDeposit = (deposit: number) => {
        tg.HapticFeedback.impactOccurred("light");
        setDeposit(String(deposit));
    };

    const handleChangeDeposit = (event: any) => {
        const newValue = event.target.value;
        
        if (newValue === "") {
            setDeposit("");
            return;
        };

        const parsedValue = parseInt(newValue, 10);

        if (!isNaN(parsedValue)) {
            setDeposit(String(parsedValue));
        } else {
            setDeposit("");
        };
    };

    const handleChangePromo = (event: any) => {
        if (promoCodePercentBonus !== 0) {
            setPromoCodePercentBonus(0);
        };

        setPromoCode(event.target.value);
    };

    const submitPromoCode = async () => {
        tg.HapticFeedback.impactOccurred("light");

        try {
            setSubmitPromoCodeProcess(true);

            const response = await PaymentService.submitPromoCode(promoCode);
      
            if (response.status === 200) {
                setPromoCodePercentBonus(response.data.percent_bonus);
                tg.HapticFeedback.notificationOccurred("success");
            };
        } catch (error: any) {
            const errorMessage = error.response.data.error.message_ru || "Ошибка применения промокода";
            appStore.addError(errorMessage);
        } finally {
            setSubmitPromoCodeProcess(false);
        };
    }

    const handleFocus = () => {
        const input = inputDepositRef.current as any;
        if (input) {
            const length = input.value.length;
            requestAnimationFrame(() => input.setSelectionRange(length, length));
            console.log(`iinput length: ${length}`)
        }
    };

    return <>
        {
            appStore.checkInvoiceId && <WaitPaidInvoice 
            invoiceId={appStore.checkInvoiceId} 
            cancel={(success: boolean | null = null) => {
                appStore.checkInvoiceId = null;
                if (success === true) {
                    cancel();
                }
            }}/>
        }
        <Overview cancel={() => cancel()} zIndex={52}>
            <div className={styles.body}>
                {/* <span className={styles.header}>Купить <span>PromoCoin</span></span> */}
                <span className={styles.header}>Пополнить баланс</span>
                {/* <div className={styles.description}>
                    <span>Почему это выгодно?</span>
                    <ul>
                        <li>Пользователи подписываются осознанно – лимит предотвращает массовые нецелевые подписки</li>
                        <li>Мы не засчитаем пользователя, отписавшегося в течение дня, а за отписку в течение недели пользователь получит штраф</li>
                        <li>Цены формируются рынком, поэтому вы не переплачиваете</li>
                    </ul>
                </div> */}
                <div className={styles.payment_form}>
                    <div className={styles.promocode_container}>
                        <span>ВВЕДИТЕ ПРОМОКОД</span>
                        <div className={styles.promocode_input}>
                            <input type="text" placeholder='ВВЕДИТЕ ПРОМОКОД' value={promoCode} onChange={handleChangePromo}/>
                            <button 
                                onClick={submitPromoCode}
                                style={submitPromoCodeProcess ? {color: "transparent"} : {}}
                                disabled={submitPromoCodeProcess}
                            >
                                {submitPromoCodeProcess && <div className={styles.spinner_wrapper}><Spinner/></div>}ПРИМЕНИТЬ
                            </button>
                        </div>
                        <div className={styles.promocode_effect}>
                            Ваш бонус {promoCodePercentBonus}% промокоинов к пополнению
                        </div>
                    </div>
                    <div className={styles.payment_sum}>
                        <span>Минимальная сумма пополнения 10&nbsp;<MoneyIcon/></span>
                        <div className={styles.input_wrapper}>
                            <input type="text" ref={inputDepositRef} value={deposit} onChange={handleChangeDeposit} onFocus={handleFocus} />
                        </div>
                        <div className={styles.fast_buttons}>
                            <button onClick={() => updateDeposit(100)}>100</button>
                            <button onClick={() => updateDeposit(500)}>500</button>
                            <button onClick={() => updateDeposit(1000)}>1000</button>
                            <button onClick={() => updateDeposit(2500)}>2500</button>
                            <button onClick={() => updateDeposit(5000)}>5000</button>
                        </div>
                        <div className={styles.info}>
                            <span>На баланс поступит:&nbsp;<span className={styles.money}>{deposit ? Math.floor(Number(deposit) + Number(deposit) * (promoCodePercentBonus / 100)) : 0}&nbsp;<MoneyIcon/></span></span>
                            <span>К оплате:&nbsp;<span className={styles.money}>{deposit ? deposit : 0} руб</span></span>
                        </div>
                    </div>
                    <button 
                        onClick={() => appStore.createDepositInvoice(Number(deposit), promoCodePercentBonus !== 0 ? promoCode : null)}
                        style={appStore.processInvoice === "deposit" ? {color: "transparent"} : {}}
                        disabled={appStore.processInvoice === "deposit"}
                    >
                        {appStore.processInvoice === "deposit" && <div className={styles.spinner_wrapper}><Spinner/></div>}ОПЛАТИТЬ
                    </button>
                </div>
                <div className={styles.footer}>
                    <span>ИП Тен Аркадий Александрович ИНН 550616511061</span>
                    <div>
                        <a onClick={() => tg.openLink(config.offerLink)}>Публичная оферта</a>
                        <a onClick={() => tg.openTelegramLink(config.supportLink)}>Поддержка</a>
                    </div>
                </div>
            </div>
        </Overview>
    </>;
};

export default observer(PaymentWindow);


// <div className={styles.products}>
//                     {
//                         products.map((product, index) => (
//                             <div className={styles.product} key={`product_${index}`}>
//                                 <div className={styles.product_info}>
//                                     <span className={styles.price}>{product.product_value}<MoneyIcon/></span>
//                                     {/* <span className={styles.product_description}>≈300 подписчиков</span> */}
//                                 </div>
//                                 <div className={styles.product_payment}>
//                                     <div className={styles.payment_buttons}>
//                                         <button className={styles.pay_star_button} disabled={appStore.processInvoice === `${product.id}telegram`} onClick={() => appStore.createInvoice(product.id, "telegram")}>
//                                             {appStore.processInvoice === `${product.id}telegram` ? <Spinner/> : <><StarIcon/>{product.price_stars}</>}
//                                         </button>
//                                         <button className={styles.pay_button} disabled={appStore.processInvoice === `${product.id}robokassa`} onClick={() => appStore.createInvoice(product.id, "robokassa")}>
//                                             {appStore.processInvoice === `${product.id}robokassa` ? <Spinner/> : <>{product.price_rubs} руб</>}
//                                         </button>
//                                     </div>
//                                     {product.old_price && <span className={styles.old_price}>{product.old_price} руб</span>}
//                                 </div>
//                             </div>
//                         ))
//                     }
//                 </div>